import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { API, Schemas, LingoApiResponse } from "@thenounproject/lingo-core";
import * as actionTypes from "../actions/actionTypes";

const { CALL_API } = API;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchSpace = (spaceId: string | number): any => {
  return {
    id: spaceId,
    [CALL_API]: {
      types: [
        actionTypes.FETCH_SPACE,
        actionTypes.FETCH_SPACE_SUCCESS,
        actionTypes.FETCH_SPACE_FAILURE,
      ],
      endpoint: `spaces/${spaceId}`,
      schema: Schemas.SPACE,
    },
  };
};

export default function () {
  const dispatch = useDispatch();
  return useCallback(
    (spaceId: string | number) => {
      return dispatch(fetchSpace(spaceId)) as unknown as Promise<LingoApiResponse>;
    },
    [dispatch]
  );
}
